import nwg1 from "./1.png";
import nwg2 from "./2.png";
import nwg3 from "./3.png";
import nwg4 from "./4.png";
import nwg5 from "./5.png";

const nwg = [nwg1, nwg2, nwg3, nwg4, nwg5];

export default nwg;
